/* eslint-disable @typescript-eslint/no-explicit-any */
import { Avatar, Grid, Typography } from '@mui/material';
import { Box } from '@mui/system';
import _ from 'lodash';
import React, { useState } from 'react';
import CardfordownloadEditViewAction from '../../../components/CardfordownloadEditViewAction/CardfordownloadEditViewAction';
import CardForExpiredDocs from '../../../components/CardForExpiredDocs/CardForExpiredDocs';
import { fonts, themes } from '../../../themes/themes';
import CustomModal from '../../CustomModal/CustomModal';
import CustomPlainCardTile from '../../../components/CustomPlainCardTile/CustomPlainCardTile';
import emptyIcon from '../../../../assets/images/empty_icon.svg';
import AddDependentsController from '../AddDependents/AddDependentsController';
import EditDependentsController from '../EditDependents/EditDependentsController';
import ActivedocCard from '../../../components/ActivedocCard';
import Warning from '../../WarningModal/Warning';

interface ModalProps {
  isModalOpen?: boolean;
  closeModal: any;
  setDocsIdFordeletion: (id: number) => void;
  depdDocumentsList: any;
  setDependentAttachedDoc: (id: number) => void;
  trans?: any;
}
const DepDocumentsPresenter = ({
  isModalOpen,
  closeModal,
  depdDocumentsList,
  setDocsIdFordeletion,
  setDependentAttachedDoc,
  trans,
}: ModalProps) => {
  const [addDependentsDocsModal, showAddDependentsDocsModal] = useState(false);
  const [editDepDocuments, seteditDepDocuments] = useState([]);

  const [editDepDocumentsModal, setEditDepDocumentsModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [deleteDocId, setDeleteDocId] = useState<number>(0);
  const [title, setTitle] = useState()

  const handleEditDocuments = (activedepDocs: any) => {
    seteditDepDocuments(activedepDocs);
    setEditDepDocumentsModal(true);
  };
  const handleViewNDownload = (id: number) => {
    setDependentAttachedDoc(id);
  };
  const handleDocDeleteModal = (activedepDocs: any) =>{
    setOpenDeleteModal(true)
    setDeleteDocId(activedepDocs?.activedepDocs?.id)
    setTitle(activedepDocs?.doc_type)
  }
  const handelExpDocDeleteModal = (expireddepDocs: any) =>{
    setOpenDeleteModal(true)
    setDeleteDocId(expireddepDocs?.expireddepDocs?.id)
    setTitle(expireddepDocs?.doc_type)
  }

  const handleDelete = () => {
    setDocsIdFordeletion(deleteDocId);
  };

  return (
    <>
      <CustomModal
        isModalOpen={isModalOpen}
        modalHeight="650px"
        modalWidth="1000px"
      >
        <Grid container spacing={2}>
          <Grid item style={{ marginTop: '0.5em' }}>
            <i
              className="las la-arrow-left"
              style={{ color: themes.primary, cursor: 'pointer' }}
              onClick={closeModal}
            ></i>
          </Grid>
          <Grid item>
            <Avatar src={depdDocumentsList?.photo} />
          </Grid>
          <Grid item>
            <Typography
              style={{
                fontFamily: 'Lato',
                fontSize: '0.9em',
                fontWeight: 'bold',
              }}
            >
              {depdDocumentsList
                ? depdDocumentsList?.first_name +
                  ' ' +
                  depdDocumentsList?.last_name
                : ''}
            </Typography>
            <Typography
              style={{
                fontFamily: 'Lato',
                fontSize: '0.7em',
                color: '#575757',
              }}
            >
              {depdDocumentsList
                ? depdDocumentsList?.relationship_type?.name
                : ''}
            </Typography>
          </Grid>
        </Grid>
        <Box style={{ marginBottom: '24px' }} />
        <Grid container spacing={2}>
          <Grid item xs={6} sm={6} md={6} lg={6}>
            <Box
              style={{ borderRadius: '15px', border: '1px solid #0000001F' }}
            >
              <ActivedocCard
                card_title={trans('Active Documents')}
                card_subtitle={`${trans('Total')} : ${depdDocumentsList
                  ?.active_dependent_documents?.length}`}
                card_height="310px"
                onClick={() => {
                  showAddDependentsDocsModal(true);
                }}
              >
                {depdDocumentsList?.active_dependent_documents?.length > 0 ? (
                  _.map(
                    depdDocumentsList?.active_dependent_documents,
                    (activedepDocs: any) => {
                      return (
                        <CardfordownloadEditViewAction
                          tile_value={
                            activedepDocs
                              ? activedepDocs?.documen_type?.type
                              : ''
                          }
                          subtitle1={`${trans('Identifier No')} :`}
                          IdentifierNo={
                            activedepDocs
                              ? activedepDocs?.identifier_number
                              : ''
                          }
                          Issuetitle={trans('Issue')}
                          IssueDate={
                            activedepDocs ? activedepDocs?.issue_date : ''
                          }
                          Expirytitle={trans('Expiry')}
                          ExpDate={
                            activedepDocs ? activedepDocs?.validity_date : ''
                          }
                          country={
                            activedepDocs ? activedepDocs?.issue_country : ''
                          }
                          onEdit={() => handleEditDocuments(activedepDocs)}
                          onDelete={() => handleDocDeleteModal({activedepDocs,doc_type:"Dependent Documnet"})}
                          onView={() => handleViewNDownload(activedepDocs.id)}
                        />
                      );
                    },
                  )
                ) : (
                  <Grid container style={{ marginBottom: '3.8em' }}>
                    <Grid
                      item
                      xs={12}
                      style={{
                        textAlign: 'center',
                      }}
                    >
                      <img src={emptyIcon} />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      style={{
                        textAlign: 'center',
                      }}
                    >
                      <Typography
                        style={{
                          fontFamily: fonts.fontFamily,
                          fontSize: fonts.title,
                          color: themes.blackDefault,
                          fontWeight: 'bold',
                        }}
                      >
                        {trans('Not Added')}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      style={{
                        textAlign: 'center',
                      }}
                    >
                      <Typography
                        style={{
                          fontFamily: fonts.fontFamily,
                          fontSize: fonts.subtitle,
                          color: themes.defaultIcon,
                        }}
                      >
                        {trans(
                          'Currently you haven’t any Active Dependents Documents',
                        )}
                      </Typography>
                    </Grid>
                  </Grid>
                )}
              </ActivedocCard>
            </Box>
          </Grid>
          <Grid item xs={6} sm={6} md={6} lg={6}>
            <Box
              style={{ borderRadius: '15px', border: '1px solid #0000001F' }}
            >
              <CustomPlainCardTile
                card_title={trans('Expired Documents')}
                title_color="#F44336"
                card_height="310px"
                card_subtitle={`${trans('Total')}: ${depdDocumentsList
                  ?.expired_dependent_documents?.length}`}
              >
                {depdDocumentsList?.expired_dependent_documents?.length > 0 ? (
                  _.map(
                    depdDocumentsList?.expired_dependent_documents,
                    (expireddepDocs: any) => {
                      return (
                        <CardForExpiredDocs
                          tile_value={
                            expireddepDocs
                              ? expireddepDocs.documen_type?.type
                              : ''
                          }
                          subtitle1={`${trans('Identifier No')}: `}
                          IdentifierNo={
                            expireddepDocs
                              ? expireddepDocs.identifier_number
                              : ''
                          }
                          Issuetitle={`${trans('Issue')}: `}
                          IssueDate={
                            expireddepDocs ? expireddepDocs?.issue_date : ''
                          }
                          Expirytitle={`${trans('Expired')}: `}
                          ExpDate={
                            expireddepDocs ? expireddepDocs?.validity_date : ''
                          }
                          country={
                            expireddepDocs ? expireddepDocs?.issue_country : ''
                          }
                          onDelete={() =>
                            handelExpDocDeleteModal({expireddepDocs,doc_type:"Expired Document"})
                          }
                          onView={() => handleViewNDownload(expireddepDocs?.id)}
                        />
                      );
                    },
                  )
                ) : (
                  <Grid container>
                    <Grid
                      item
                      xs={12}
                      style={{
                        textAlign: 'center',
                      }}
                    >
                      <img src={emptyIcon} />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      style={{
                        textAlign: 'center',
                      }}
                    >
                      <Typography
                        style={{
                          fontFamily: fonts.fontFamily,
                          fontSize: fonts.title,
                          color: themes.blackDefault,
                          fontWeight: 'bold',
                        }}
                      >
                        {trans('Not Added')}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      style={{
                        textAlign: 'center',
                      }}
                    >
                      <Typography
                        style={{
                          fontFamily: fonts.fontFamily,
                          fontSize: fonts.subtitle,
                          color: themes.defaultIcon,
                        }}
                      >
                        {trans(
                          'Currently you haven’t any Expired Dependents Documents',
                        )}
                      </Typography>
                    </Grid>
                  </Grid>
                )}
              </CustomPlainCardTile>
            </Box>
          </Grid>
        </Grid>
      </CustomModal>
      <Warning 
           openmodal={openDeleteModal}
           oncancel={() => setOpenDeleteModal(false)}
           infoMessage={trans(`Are You Deleting this ${title}?`)}
           onconfirm={handleDelete}
          />
      {addDependentsDocsModal && (
        <AddDependentsController
          mainModel={closeModal}
          depdDocumentsList={depdDocumentsList}
          isModalOpen={addDependentsDocsModal}
          closeModal={() => {
            showAddDependentsDocsModal(false);
          }}
          trans={trans}
        />
      )}
      {editDepDocumentsModal && (
        <EditDependentsController
          mainModel={closeModal}
          editDepDocuments={editDepDocuments}
          isModalOpen={editDepDocumentsModal}
          closeModal={() => setEditDepDocumentsModal(false)}
          trans={trans}
        />
      )}
    </>
  );
};
export default DepDocumentsPresenter;
